"use client";

import Image from 'next/image'
import { FaCcVisa, FaCcMastercard, FaCcDiscover, FaCcAmex, FaMoneyCheckAlt } from "react-icons/fa";
import { MdHealthAndSafety } from "react-icons/md";
import { usePathname } from "next/navigation";

export default function Footer() {
  const pathname = usePathname();
  const showDotPharmacy = pathname === "/";
  const year = new Date().getFullYear();

  return (
    <footer className="relative mt-auto overflow-hidden bg-gradient-to-b from-[#f7fbff] via-white to-[#eef7ff] text-slate-700" aria-labelledby="footer-heading">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-32 -left-10 h-64 w-64 rounded-full bg-emerald-400/12 blur-3xl" />
        <div className="absolute top-10 right-0 h-56 w-56 rounded-full bg-blue-400/12 blur-3xl" />
      </div>

      {/* Accreditation bar */}
      <div className="relative border-b border-slate-200 bg-white">
        <div className="container mx-auto px-4 py-5 flex flex-col items-center gap-5">
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 xl:gap-8">
            <a
              href="http://www.pcab.org/accredited-locations.html"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-[clamp(70px,10vw,110px)] items-center rounded-xl bg-white/90 px-4 py-3 shadow-sm ring-1 ring-gray-200/80 backdrop-blur hover:-translate-y-0.5 hover:ring-amber-300/60 transition"
            >
              <Image
                src="/images/logo-pcab-gold.jpg"
                alt="PCAB Accreditation Gold"
                width={320}
                height={120}
                className="h-full w-auto"
              />
            </a>
            <a
              href="http://www.pcab.org/accredited-locations.html"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-[clamp(70px,10vw,110px)] items-center rounded-xl bg-white/90 px-4 py-3 shadow-sm ring-1 ring-gray-200/80 backdrop-blur hover:-translate-y-0.5 hover:ring-amber-300/60 transition"
            >
              <Image
                src="/images/logo-pcab.jpg"
                alt="PCAB Accreditation"
                width={280}
                height={120}
                className="h-full w-auto"
              />
            </a>
            <a
              href="http://www.gspo.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-[clamp(70px,10vw,110px)] items-center rounded-xl bg-white/90 px-4 py-3 shadow-sm ring-1 ring-gray-200/80 backdrop-blur hover:-translate-y-0.5 hover:ring-amber-300/60 transition"
            >
              <Image
                src="/images/logo-gspo.jpg"
                alt="GSPO Accreditation"
                width={300}
                height={120}
                className="h-full w-auto"
              />
            </a>
            <a
              href="https://www.pccarx.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-[clamp(70px,10vw,110px)] items-center rounded-xl bg-white/90 px-4 py-3 shadow-sm ring-1 ring-gray-200/80 backdrop-blur hover:-translate-y-0.5 hover:ring-amber-300/60 transition"
            >
              <Image
                src="/images/icon-pcca.png"
                alt="PCCA"
                width={220}
                height={120}
                className="h-full w-auto"
              />
            </a>
            <a
              href="https://www.iacprx.org"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-[clamp(70px,10vw,110px)] items-center rounded-xl bg-white/90 px-4 py-3 shadow-sm ring-1 ring-gray-200/80 backdrop-blur hover:-translate-y-0.5 hover:ring-amber-300/60 transition"
            >
              <Image
                src="/images/icon-iacp.png"
                alt="IACP"
                width={220}
                height={120}
                className="h-full w-auto"
              />
            </a>
            <a
              href="https://www.legitscript.com/websites/?checker_keywords=cfspharmacy.com"
              target="_blank"
              rel="noopener noreferrer"
              title="Verify LegitScript Approval for www.cfspharmacy.com"
              className="inline-flex h-[clamp(70px,10vw,110px)] items-center rounded-xl bg-white/90 px-4 py-3 shadow-sm ring-1 ring-gray-200/80 backdrop-blur hover:-translate-y-0.5 hover:ring-amber-300/60 transition"
            >
              <Image
                src="https://static.legitscript.com/seals/890771.png"
                alt="Verify Approval for www.cfspharmacy.com"
                width={73}
                height={79}
                className="h-full w-auto"
              />
            </a>
          </div>
          {showDotPharmacy && (
            <div className="flex flex-wrap justify-center items-center gap-4">
              <a
                href="https://safe.pharmacy/buy-safely/?url=cfspharmacy.pharmacy"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-[clamp(70px,10vw,110px)] items-center rounded-xl bg-white/90 px-4 py-3 shadow-sm ring-1 ring-gray-200/80 backdrop-blur hover:-translate-y-0.5 hover:ring-amber-300/60 transition"
              >
                <Image
                  src="/images/icon-dottld.jpg"
                  alt=".Pharmacy Verified"
                  width={220}
                  height={120}
                  className="h-full w-auto"
                />
              </a>
              <a
                title="Digital Pharmacy"
                href="https://mybadges.us.openbadges.me/api/badgeitem/7aa92466-a8fb-4e63-b7da-f35f21b17da1/metadata"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-[clamp(70px,10vw,110px)] items-center justify-center rounded-xl bg-white/90 px-4 py-3 shadow-sm ring-1 ring-gray-200/80 backdrop-blur hover:-translate-y-0.5 hover:ring-amber-300/60 transition"
              >
                <img
                  src="https://openbadges.blob.core.windows.net/bakedbadges-us/f279c890-aa1f-43bc-822d-c78c619a148e-6d09d6f6-cd16-469d-ab5a-6f9fb2dde5ca.png"
                  alt="Digital Pharmacy"
                  width={100}
                  height={100}
                  className="h-full w-auto"
                />
              </a>
            </div>
          )}
          <a
            href="/commitment-to-quality/"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-700 hover:bg-emerald-600 text-white text-sm font-semibold rounded-full shadow-md hover:shadow-lg transition-all duration-200"
          >
            Our Commitment to Quality →
          </a>
        </div>
      </div>

      <div className="relative">
        <div className="container mx-auto px-4 py-12 lg:py-16">
          <div className="grid gap-10 lg:grid-cols-[1.2fr_1fr] xl:grid-cols-[1.3fr_1fr_0.9fr]">

            {/* Brand + Contact */}
            <section className="space-y-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-lg shadow-slate-200/70">
              <div className="grid gap-6 md:grid-cols-2">
                <div>
                  <h2 className="text-lg font-semibold text-slate-900">Contact</h2>
                  <p className="mt-3 text-sm leading-relaxed text-slate-700">
                    400 Fellowship Road, Suite 100<br />
                    Mount Laurel, NJ 08054
                  </p>
                  <p className="mt-3 text-sm text-slate-700">Phone: 844.822.7379</p>
                  <p className="text-sm text-slate-700">Fax: 800.786.1405</p>
                  <p className="text-sm text-slate-700">Email: <a href="mailto:csr@cfspharmacy.com" className="text-emerald-700 hover:text-emerald-600">csr@cfspharmacy.com</a></p>
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-slate-900">We Care</h2>
                  <p className="mt-3 text-sm leading-relaxed text-slate-700">
                    We are in the business of caring for people and pets. Our patients are our number one priority. See what patients and prescribers are saying about CareFirst Specialty Pharmacy.
                  </p>
                  <a href="/reviews/" className="mt-3 inline-flex items-center text-sm font-semibold text-emerald-700 hover:text-emerald-600">
                    Read Reviews
                    <span className="ml-1 text-base" aria-hidden="true">→</span>
                  </a>
                </div>
              </div>

              {/* Newsletter */}
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-5 shadow-inner shadow-slate-200">
                <h2 className="text-lg font-semibold text-slate-900">Newsletter</h2>
                <p className="mt-2 text-sm text-slate-700">
                  Submit your email below and receive updates, latest innovations in compounding for patients and practitioners.
                </p>
                <form className="mt-4 flex flex-col gap-3 sm:flex-row" aria-label="Newsletter subscription">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:border-emerald-400/60 focus:outline-none focus:ring-2 focus:ring-emerald-400/40"
                  />
                  <button
                    type="submit"
                    className="whitespace-nowrap rounded-lg bg-gradient-to-r from-emerald-500 to-teal-400 px-4 py-2.5 text-sm font-semibold text-white shadow-lg shadow-emerald-500/30 transition hover:shadow-emerald-500/40 hover:brightness-105"
                  >
                    Subscribe
                  </button>
                </form>
              </div>
            </section>

            {/* Navigation */}
            <nav aria-label="Footer navigation" className="space-y-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-lg shadow-slate-200/70">
              <div>
                <h2 className="text-lg font-semibold text-slate-900">Navigate</h2>
                <ul className="mt-4 grid gap-3 text-sm text-slate-700 sm:grid-cols-2">
                  {[
                    { name: "Home", href: "/" },
                    { name: "Compounding", href: "/compounding/what-is-compounding/" },
                    { name: "Contact Us", href: "/contact-us/" },
                    { name: "Refill Rx", href: "/refill-rx/" },
                    { name: "Reviews", href: "/reviews/" },
                    { name: "How to Order", href: "/how-to-order/" },
                    { name: "About Us", href: "/about/" },
                    { name: "Our Team", href: "/about/our-team/" },
                    { name: "Commitment to Quality", href: "/commitment-to-quality/" },
                    { name: "Careers", href: "/careers/" },
                    { name: "Customer Survey", href: "/customer-survey/" },
                    { name: "Drug Disposal", href: "/drug-disposal/" },
                    { name: "Our Philosophy", href: "/our-philosophy/" },
                    { name: "Shipping Info", href: "/shipping-info/" },
                    { name: "Return Policy", href: "/return-policy/" },
                    { name: "Privacy Policy", href: "/privacy-policy/" },
                    { name: "Cookie Policy", href: "/cookie-policy/" },
                    { name: "Notice of Privacy Practices", href: "/notice-of-privacy-practices/" },
                    { name: "FAQs", href: "/faq/" },
                    { name: "Blog", href: "/blog/" },
                  ].map((link, i) => (
                    <li key={i}>
                      <a
                        href={link.href}
                        className="inline-flex w-full items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 font-semibold text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:border-emerald-200 hover:bg-white hover:shadow-md"
                      >
                        <span>{link.name}</span>
                        <span aria-hidden="true" className="text-emerald-600">→</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </nav>

            {/* Forms + Payments */}
            <section className="space-y-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-lg shadow-slate-200/70">
              <nav aria-label="Forms">
                <h2 className="text-lg font-semibold text-slate-900">Forms</h2>
                <ul className="mt-4 space-y-3 text-sm text-slate-700">
                  {[
                    { label: "Patient Registration", href: "/patient/" },
                    { label: "Pet Owner Registration", href: "/patient/" },
                    { label: "Transfer Prescription", href: "/patient/" },
                    { label: "Prescriber Form", href: "/prescriber-form/" },
                    { label: "Veterinarian Form", href: "/prescriber-form/" },
                    { label: "Rx Authorization Fax Form (HUMAN)", href: "/pdf/Human_Prescription_Authorization_Fax_Form.pdf" },
                    { label: "Rx Authorization Fax Form (VET)", href: "/pdf/Vet_Prescription_Authorization_Fax_Form.pdf" },
                    { label: "HIPAA Waiver and Credit Card Authorization", href: "/hipaa-cc-form/" }
                  ].map((link, i) => (
                    <li key={i}>
                      <a
                        href={link.href}
                        className="inline-flex w-full items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 font-semibold text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:border-emerald-200 hover:bg-white hover:shadow-md"
                      >
                        <span>{link.label}</span>
                        <span aria-hidden="true" className="text-emerald-600">→</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>

              <div>
                <h2 className="text-lg font-semibold text-slate-900">Accepted Payments</h2>
                <div className="mt-4 flex flex-wrap items-center gap-4 text-3xl text-white">
                  <FaCcAmex title="American Express" className="text-blue-500" />
                  <MdHealthAndSafety title="CareCredit" className="text-green-500" />
                  <FaCcDiscover title="Discover" className="text-orange-400" />
                  <FaMoneyCheckAlt title="eCheck" className="text-gray-300" />
                  <FaCcMastercard title="Mastercard" className="text-red-500" />
                  <FaCcVisa title="Visa" className="text-blue-400" />
                </div>
              </div>
            </section>
          </div>

          {/* Footer note */}
          <div className="mt-10 border-t border-slate-200 pt-6 text-xs text-slate-500 text-center">
            <p>CareFirst Specialty Pharmacy is licensed by the New Jersey Board of Pharmacy.</p>
            <p className="mt-1">© {year} CareFirst Specialty Pharmacy, LLC. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  )
}
